import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import { Field, ID, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import type { CheckoutSessionResult } from '../../payment/IPaymentGateway'

@InputType()
export class CreateOrderCheckoutSessionArgs extends ActionArgs {
  @Field(() => ID)
  orderId: string

  @Field(() => ID, { nullable: true })
  userId?: string

  @Field(() => Boolean, { nullable: true })
  fromCheckout?: boolean

  // Client-provided line items (e.g. the invoice "Pay Balance" flow charging a single
  // balance amount). Omitted/empty means the order's own items/shipping/tax/discount are used.
  @Field(() => GraphQLJSON, { nullable: true })
  lineItems?: any[]

  @Field(() => String)
  successUrl: string

  @Field(() => String)
  cancelUrl: string
}

// TResult is the gateway-created checkout session object; the router maps it to { sessionId, url }.
export interface ICreateOrderCheckoutSession extends IAction<CheckoutSessionResult, CreateOrderCheckoutSessionArgs> {}
